import useOnScreen from "../../components/UseOnScreen/UseOnScreen"; 
import TypingEffect from "../../components/Animation/TypingEffect";
import "../Services/CouplesAndFamilys.css";

const CouplesAndFamilys = () => {
    const [aboutRef, isVisible] = useOnScreen({ threshold: 0.5, once: true });
    const familysText = "Decisões importantes, rupturas, dificuldades para fazer adaptações e conflitos entre os membros da família, são algumas das questões que podemos abordar.";

  return (
    <div id="couples-and-familys" className="" ref={aboutRef}>
      <div className="familys-container">
        <div className="familys-text">
                {isVisible ? (
                        <>
                            <TypingEffect
                                text={familysText}
                                speed={70}    
                                className="familys-phrase"
                                />
                        </>
                    ) : (
                        <div className="placeholder-text">
                            <span className="familys-phrase">{familysText}</span>
                        </div>
                    )}
        </div>
        <div className="familys-second-text">
          <h1>Atendimento para<br></br>Casais e Famílias</h1>
          <span>
            No atendimento de casais e famílias o foco não está apenas em cada indivíduo isoladamente, mas nas interações recíprocas, emoções, histórias de vida e como as formas de relacionamento se entrelaçam. Esse trabalho oferece uma escuta técnica e neutra, explorando as narrativas, para que cada um possa perceber os padrões que se repetem na relação e encontrar caminhos mais autênticos e conscientes.
          <br></br>
          <br></br>
          <strong>Se sentem que estão presos a ciclos difíceis ou enfrentam desafios que não conseguem resolver sozinhos, marcar uma sessão pode ser o primeiro passo para mudar o rumo e construir um novo caminho.</strong>
          </span>
        </div>
      </div>
    </div>
  );
}

export default CouplesAndFamilys;
